<template>
  <div class="dn-function-button">
    <!-- -->
    <button
      v-if="linkLocation === ''"
      :id="buttonId"
      :class="classes"
      @click.prevent="executeCallback($event)"
      :disabled="disabled"
    >
      <fa-icon v-if="faIcon !== 'none' && loading === false" :icon="faIcon" />
      <span v-if="faIcon !== 'none' && loading === false"> &nbsp; </span>
      <span v-if="loading === false">
        {{ text }}
      </span>
      <i v-else class="p-0 element-loading" />
    </button>
    <!-- -->
    <a
      v-else
      :id="buttonId"
      :class="classes"
      :href="linkLocation"
    >
      <fa-icon v-if="faIcon !== 'none' && loading === false" :icon="faIcon" />
      <span v-if="faIcon !== 'none' && loading === false"> &nbsp; </span>
      <span v-if="loading === false">
        {{ text }}
      </span>
      <i v-else class="p-0 element-loading" />
    </a>
    <!-- -->
  </div>
</template>

<script>
  import { constants } from "@/const"

  export default {
    props: {
      buttonId: {
        type: String,
        default: "btnId"
      },
      text: {
        type: String,
        default: "Button text"
      },
      callbackFn: {
        type: Function,
        default: Function
      },
      size: {
        type: Number,
        default: 1
      },
      linkLocation: {
        type: String,
        default: ""
      },
      extraClasses: {
        type: String,
        default: ""
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      includeEventInParams: {
        type: Boolean,
        default: false
      }
      ,
      callbackParams: {
        type: Array,
        default: null
      },
      faIcon: {
        type: String,
        default: "none"
      },
    },
    computed: {
      classes: function () {
        let classes = this.extraClasses + " btn "

        switch (this.size) {
        case constants.SIZES.SMALL:
          classes += "dn-btn-small "
        case constants.SIZES.LARGE:
          classes += "btn-large dn-btn-large "       
        }

        if(this.loading || this.disabled){
          classes += "disabled";
        }

        return classes.trim()
      }
    },
    methods: {
      executeCallback($event){
        //both event param and callback params
        if(this.includeEventInParams === true && this.IsNotNullOrUndefined(this.callbackParams)){
          this.callbackFn($event, ...callbackParams)
        }
        //just the event param
        else if(this.includeEventInParams === true){
          this.callbackFn($event)
        }
        //just the callback params
        else if(this.IsNotNullOrUndefined(this.callbackParams)){
          this.callbackFn(...this.callbackParams)
        }
        //no params
        else{
          this.callbackFn();
        }
      }
    }
  }
</script>


<style lang="scss">
.dn-function-button {
  display: inline;
}
</style>